// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
/**
 * @deprecated Since numbro introduction. Use CommonUtils/formatNumber instead.
 * thanks <3
 */

const formatValue = (
  value,
  { type = 'decimal', decimalPlaces = 0, includeThousandsSeparator = true } = {},
) =>
  Math.abs(value) <= 999999999
    ? new Intl.NumberFormat('en-US', {
        style: type,
        currency: 'USD',
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
        useGrouping: includeThousandsSeparator,
      }).format(value)
    : `${type === 'currency' ? '$' : ''}${value.toExponential(2)}${type === 'percent' ? '%' : ''}`;

export default formatValue;
